export default __webpack_public_path__ + "static/media/microphone-solid-full.958cc888.svg";